import React, { Component } from "react";
import { connect } from "react-redux";
import { store } from "../../../store";

import { Wrapper, Card, PrimaryButton } from "app/NativeComponents/common";

import { TextButton } from "app/NativeComponents/snippets";

import {
  showSuccess,
  setShareOptions,
  toggleActionSheet
} from "app/NativeActions";

import ClipboardButton from "react-clipboard.js";

class ShareButtons extends Component {
  shareCode() {
    this.props.showSuccess("Invite code copied. Thanks for sharing!");
  }

  componentDidMount() {
    this.props.setShareOptions({
      message: this.props.message,
      title: this.props.title,
      subject: this.props.subject,
      url: this.props.url
    });
  }

  render() {
    if (this.props.more_options) {
      return (
        <Wrapper>
          <Card>
            <ClipboardButton
              onClick={this.shareCode.bind(this)}
              data-clipboard-text={
                this.props.shareOptions.message +
                " " +
                this.props.shareOptions.url
              }
              className={"primary-button flex-item"}
            >
              Copy Invite Code
            </ClipboardButton>
          </Card>
          <TextButton
            onPress={() => this.props.toggleActionSheet("share_more_options")}
            text="More Options"
          />
        </Wrapper>
      );
    }

    return (
      <Wrapper>
        <Card>
          <ClipboardButton
            onClick={this.shareCode.bind(this)}
            data-clipboard-text={
              this.props.shareOptions.message +
              " " +
              this.props.shareOptions.url
            }
            className={"primary-button flex-item"}
          >
            Copy Invite Code
          </ClipboardButton>
        </Card>
      </Wrapper>
    );
  }
}
const mapStateToProps = ({ drawer }) => {
  const { shareOptions } = drawer;
  return {
    shareOptions
  };
};

export default connect(mapStateToProps, {
  showSuccess,
  setShareOptions,
  toggleActionSheet
})(ShareButtons);
